// extracted by mini-css-extract-plugin
module.exports = {"content":"Research_content__3kziw","videoNotFound":"Research_videoNotFound__xrWcZ"};